import React from 'react';
import { ns } from '@leverege/i18n';
import { useValueChange } from '@leverege/ui-hooks';
import { Checkbox } from '@leverege/ui-elements';
import Model from "./ValueVisibilizer.js";
import { jsx as _jsx } from "react/jsx-runtime";
const {
  t
} = ns('ui-attributes.ValueVisibilizerEditor');
export default function ValueVisibilizerEditor(props) {
  const {
    value,
    id,
    className
  } = props;
  const onModelChange = useValueChange(Model, props);
  return /*#__PURE__*/_jsx(Checkbox, {
    id: id,
    className: className,
    eventData: "setVisible",
    label: "Is Visible?",
    hint: t('hint'),
    onChange: onModelChange,
    style: {
      minWidth: '15em'
    },
    value: Model.getVisible(value)
  });
}
ValueVisibilizerEditor.isInline = true;